import { render, staticRenderFns } from "./ContactPreferences.vue?vue&type=template&id=35c1c55a&scoped=true&"
import script from "./ContactPreferences.vue?vue&type=script&lang=js&"
export * from "./ContactPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ContactPreferences.vue?vue&type=style&index=0&id=35c1c55a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1c55a",
  null
  
)

export default component.exports